if (!window.Eurus.loadedScript.has("sticky-atc.js")) {
  window.Eurus.loadedScript.add("sticky-atc.js");

  requestAnimationFrame(() => {
    document.addEventListener("alpine:init", () => {
      // wimSeed: precio que ya ha calculado el servidor (resolutor wim-subscription-price).
      // Se siembra el estado con el para que el primer wim:subscription-pricing-changed
      // no cambie nada y la barra no parpadee, igual que en la ficha (ClickUp 869f5crg2).
      Alpine.data("xStickyATC", (sectionId, is_combined, wimSeed = {}) => ({
        openDetailOnMobile: false,
        currentAvailableOptions: [],
        options: [],
        wimIsSubscription: false,
        wimSubscriptionPlanText: "",
        wimPlansData: null,
        wimDisplayPriceCents: wimSeed.priceCents ?? null,
        wimDisplayCompareCents: wimSeed.compareCents ?? null,
        wimDisplayPriceFormatted: wimSeed.priceFormatted || "",
        wimDisplayCompareFormatted: wimSeed.compareFormatted || "",
        wimDisplayWeightGrams: 0,
        wimDisplayWeightLabel: "",
        init() {
          document.addEventListener("wim:subscription-changed", (e) => {
            this.wimIsSubscription = e.detail.isSubscription;
            this.syncWimSubscriptionDisplay();
          });
          document.addEventListener("wim:subscription-plan-changed", () => {
            this.syncWimSubscriptionDisplay();
          });
          document.addEventListener("wim:subscription-pricing-changed", (e) => {
            const detail = e.detail || {};
            this.wimDisplayPriceCents = detail.priceCents ?? null;
            this.wimDisplayCompareCents = detail.compareCents ?? null;
            this.wimDisplayPriceFormatted = detail.priceFormatted || "";
            this.wimDisplayCompareFormatted = detail.compareFormatted || "";
            this.wimDisplayWeightGrams = detail.totalWeightGrams ?? 0;
            this.wimDisplayWeightLabel = detail.totalWeightLabel || "";
          });

          if (!is_combined) {
            this.variants = xParseJSON(
              this.$el.getAttribute("x-variants-data"),
            );
          }

          document.addEventListener(
            `eurus:product-page-variant-select:updated:${sectionId}`,
            (e) => {
              if (is_combined) {
                this.renderVariant(e.detail.html);
              } else {
                ((this.currentAvailableOptions =
                  e.detail.currentAvailableOptions),
                  (this.options = e.detail.options));
              }

              this.renderProductPrice(e.detail.html);
              this.renderMedia(e.detail.html);
              this.renderColorSwatch(e.detail.html);
              this.syncWimSubscriptionDisplay();
            },
          );

          document.addEventListener("click", (e) => {
            if (e.target.closest(".wim-payment-method-picker")) {
              setTimeout(() => this.syncWimSubscriptionDisplay(), 0);
            }
          });

          this.syncWimSubscriptionDisplay();
          setTimeout(() => {
            document.dispatchEvent(
              new CustomEvent("wim:sticky-sync-request", {
                detail: { sectionId: sectionId },
              }),
            );
          }, 0);
        },
        syncWimSubscriptionDisplay() {
          const planInput = document.querySelector(
            `input[name="selling_plan"][form="product-form-${sectionId}"]`,
          );
          const planIdRaw = planInput
            ? String(planInput.value || "").trim()
            : "";
          if (!this.wimIsSubscription || !planIdRaw) {
            this.wimSubscriptionPlanText = "";
            return;
          }

          if (!this.wimPlansData) {
            const plansEl = document.querySelector(
              ".wim-payment-method-picker .wim-beans-plans-data",
            );
            if (plansEl) {
              try {
                this.wimPlansData = JSON.parse(plansEl.textContent);
              } catch (err) {
                this.wimPlansData = [];
              }
            } else {
              this.wimPlansData = [];
            }
          }

          const planId = parseInt(planIdRaw, 10);
          const plan = this.wimPlansData.find((p) => Number(p.id) === planId);
          if (!plan) {
            this.wimSubscriptionPlanText = "";
            return;
          }
          const composed = [plan.cd, plan.cb].filter(Boolean).join(" · ");
          this.wimSubscriptionPlanText = composed || plan.name || "";
        },
        renderProductPrice(html) {
          const destinations = document.querySelectorAll(
            `.price-sticky-${sectionId}`,
          );
          destinations.forEach((destination) => {
            const source = html.getElementById("price-sticky-" + sectionId);
            if (source && destination) destination.innerHTML = source.innerHTML;
          });
        },
        renderMedia(html) {
          const destination = document.getElementById(
            "product-image-sticky-" + sectionId,
          );
          const source = html.getElementById(
            "product-image-sticky-" + sectionId,
          );

          if (source && destination) destination.innerHTML = source.innerHTML;
        },
        renderVariant(html) {
          const destination = document.getElementById(
            "variant-update-sticky-" + sectionId,
          );
          const source = html.getElementById(
            "variant-update-sticky-" + sectionId,
          );

          if (source && destination) destination.innerHTML = source.innerHTML;
        },
        renderColorSwatch(html) {
          const destination = document.getElementById(
            "sticky-color-swatch-" + sectionId,
          );
          const source = html.getElementById(
            "sticky-color-swatch-" + sectionId,
          );

          if (source && destination) {
            destination.style.background = source.style.background;
            destination.className = source.className;
          }
        },
        changeOptionSticky(event) {
          Array.from(event.target.options)
            .find((option) => option.getAttribute("selected"))
            .removeAttribute("selected");
          event.target.selectedOptions[0].setAttribute("selected", "selected");
          const input = event.target.selectedOptions[0];
          const inputId = input.id;
          const targetUrl = input.dataset.productUrl;
          const variantEl = document.getElementById(
            "variant-update-sticky-" + sectionId,
          );
          document.dispatchEvent(
            new CustomEvent(
              `eurus:product-page-variant-select-sticky:updated:${sectionId}`,
              {
                detail: {
                  inputId: inputId,
                  targetUrl: targetUrl,
                  variantElSticky: variantEl,
                },
              },
            ),
          );
        },
      }));
    });
  });
}
